export enum RequestsStatsEnum {
    OpenTickets = 'open-tickets',
    DateDistribution = 'date-distribution',
    StateDistribution = 'state-distribution',
    CountryDistribution = 'country-distribution',
}